import { Map } from 'immutable';
import core, { View } from '@gin-betting/core';

const {
    utils: { getSportTypeBySportTags, getBettingOptions },
    constants: { SportType },
} = core;

export default function checkIsClickInterceptorAvailable(
    sports: Map<string, View.Sport>
) {
    const {
        url: { pagePath },
        selectedSportIds,
    } = getBettingOptions();

    const sportType = getSportTypeBySportTags(sports, selectedSportIds);
    const isBettingPage = pagePath === '';
    const isMixPage = sportType === SportType.Mix;

    return isBettingPage && isMixPage;
}
